// import CONTRATO_ASUNTOS from '@/graphql/querys/administracion/contratos/contrato/asuntos/contratoAsuntos.gql';
import AGREGAR_CONTRATO_ASUNTO from '@/graphql/mutations/administracion/contratos/contrato/asuntos/agregarContratoAsunto.gql';
import ACTUALIZAR_CONTRATO_ASUNTO from '@/graphql/mutations/administracion/contratos/contrato/asuntos/actualizarContratoAsunto.gql';
import REMOVER_CONTRATO_ASUNTO from '@/graphql/mutations/administracion/contratos/contrato/asuntos/removerContratoAsunto.gql';

export default {
  methods: {
    // Agregar Asunto
    async mixAgergarAsunto() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_ASUNTO,
          variables: {
            asunto: this.asunto,
          },
          // update: (store, { data: { agregarContratoAsunto } }) => {
          //   const query = {
          //     query: CONTRATO_ASUNTOS,
          //     variables: {
          //       idSubTema: this.idSubTema,
          //     },
          //   };
          //   const { contratoAsuntos } = store.readQuery(query);
          //   const contratoAsuntosCopia = contratoAsuntos.slice();
          //   contratoAsuntosCopia.push(agregarContratoAsunto);
          //   store.writeQuery({
          //     ...query,
          //     data: {
          //       contratoAsuntos: contratoAsuntosCopia,
          //     },
          //   });
          // },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.$emit('actualizar');
      this.cerrar();
    },
    // Actualizar Asunto
    async mixActualizarAsunto() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_CONTRATO_ASUNTO,
          variables: {
            id: this.contratoAsuntoEditar.id,
            asunto: this.asunto,
          },
          // update: (store, { data: { actualizarContratoAsunto } }) => {
          //   const query = {
          //     query: CONTRATO_ASUNTOS,
          //     variables: {
          //       idSubTema: this.contratoAsuntoEditar.idSubTema,
          //     },
          //   };
          //   const data = store.readQuery(query);
          //   const { contratoAsuntos } = data;
          //   const index = contratoAsuntos
          //     .findIndex((contratoAsunto) => contratoAsunto.id
          //     === actualizarContratoAsunto.id);
          //   if (index !== -1) {
          //     contratoAsuntos.splice(index, 1, actualizarContratoAsunto);
          //   }
          //   store.writeQuery({ ...query, data });
          // },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.$emit('actualizar');
      this.cerrar();
    },
    // Eliminar Asunto
    async mixEliminarAsunto() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CONTRATO_ASUNTO,
        variables: {
          id: this.contratoAsuntoEliminar.id,
        },
        // update: (store) => {
        //   const query = {
        //     query: CONTRATO_ASUNTOS,
        //     variables: {
        //       idSubTema: this.contratoAsuntoEliminar.idSubTema,
        //     },
        //   };
        //   const data = store.readQuery(query);
        //   const { contratoAsuntos } = data;
        //   const index = contratoAsuntos
        //     .findIndex((tema) => tema.id === this.contratoAsuntoEliminar.id);
        //   if (index !== -1) {
        //     contratoAsuntos.splice(index, 1);
        //   }
        //   store.writeQuery({ ...query, data });
        // },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.$emit('actualizar');
      this.cerrar();
    },
  },
};
